// extracted by mini-css-extract-plugin
module.exports = {"flag":"Language_flag__3Gp-M","selected":"Language_selected__2PVMK","continue":"Language_continue__3Rd8d"};